import { addHours } from 'date-fns'

const generatePrizePools = (total, positions) => {
  let prizes = [total * .5]
  let lastPercentage = .5
  for (let i = 2; i < positions; i++) {
    lastPercentage = lastPercentage / 2
    prizes.push(total * lastPercentage)
  }
  return prizes
} 

export const mockRaces = [
  {
    id: 'ed8761e7-418d-411e-936e-1d70f01c9f95',
    title: '1B 07 Race - 1 Day',
    prize: generatePrizePools(1000, 10),
    start_date: new Date(),
    end_date: addHours(new Date(), 22)
  },
  {
    id: '1fee0eab-e140-43ba-9846-2692b115880f',
    title: '5b 07 Race - 1 Week',
    prize: generatePrizePools(5000, 20),
    start_date: new Date(),
    end_date: addHours(new Date(), 165)
  },
]

export const getRaceById = id => mockRaces.filter(race => race.id == id)[0]